<!-- 评分组件，满分5颗星 -->
<template>
    <div class="l-rate">
        <h2 class="l-rate-title">指读结果：</h2>
        <div class="l-rate-container">
            <img
                v-for="(item, index) in starList"
                :key="index"
                :src="item"
                alt=""
                class="l-rate-star"
            >
        </div>
    </div>
</template>

<script>
import grayStar from '../../images/star.png'
import yellowStar from '../../images/star-active.png'

export default {
    name: 'l-rate',
    props: {
        score: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            grayStar,
            yellowStar,
            allStar: [yellowStar, yellowStar, yellowStar, yellowStar, yellowStar, grayStar, grayStar, grayStar, grayStar, grayStar],
        }
    },
    computed: {
        starList() {
            return this.allStar.slice(5 - this.score, 10 - this.score)
        },
    },
}
</script>

<style scoped>
.l-rate {
    width: 100%;
}
.l-rate-title {
    padding: 0 0 12px;
    margin: 0;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
}
.l-rate-container {
    display: flex;
    align-items: center;
}
.l-rate-star {
    width: 36px;
    height: 36px;
    margin-right: 8px;
}
</style>